module.exports = __webpack_public_path__ + "static/grid_flexible-dbbfc87d0c9fa98e6f8f1cb43f867e09.mp4";